import { FC, useMemo } from "react";
import { ActorType } from "features/new-actor/enums/actorType";
import { ActorForm } from "features/new-actor/components/ActorForm";
import { ActorLayoutVariant } from "features/new-actor/enums/actorLayoutVariant";
import { useUpiContactForm } from "./useUpiContactForm";
import { NaturalPersonFormValues } from "features/new-actor/types/naturalPersonFormValues";
import { naturalPersonFormConfig } from "features/new-actor/form/naturalPersonFormConfig";

interface UpiContactFormProps {
  handleSubmit: (contact: NaturalPersonFormValues) => void
  deleteContact?: (id: string) => void
  pendingContact?: NaturalPersonFormValues
}

export const UpiContactForm: FC<UpiContactFormProps> = ({ handleSubmit, deleteContact, pendingContact }) => {
  const { editConfig, formikRef, handleValidationChange } = useUpiContactForm(handleSubmit, deleteContact, pendingContact);

  const formConfig = useMemo(() => ({
    [ActorType.Natural]: naturalPersonFormConfig,
  }), []);

  return (
    <ActorForm<NaturalPersonFormValues>
      layoutVariant={ActorLayoutVariant.LegalEntityContact}
      formConfig={formConfig}
      editConfig={editConfig}
      formikRef={formikRef}
      onValidationChange={handleValidationChange}
      onSubmit={handleSubmit}
    />
  );
};
